/**
 * 订单管理 交易订单
 */
<template>
   <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>成本比较表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
       <el-select-tree :options="treeData" :value="value" @getValue="getSelectedValue"></el-select-tree>
      </el-form-item>
      <el-form-item >
       <el-button type="primary" style="margin:20px;" @click="exportExcel">导出Excel</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;"  @expand-change='changt' id="out-table"
    >
      <!--展开行-->
     <el-table-column type="expand">
      <template slot-scope="props">
         <el-table size="small" :data="listentryData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;"
         >
             <el-table-column  prop="" label="关联采购订单号" width="120" show-overflow-tooltip>
      </el-table-column>
            <el-table-column  prop="OName" label="2级模块" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="sumMoney" label="采购预算金额" width="200" show-overflow-tooltip>
      </el-table-column>
       <el-table-column  prop="KCMoney" label="库存金额" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FAllAmount" label="采购订单金额" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FAmountbill" label="采购比（采购订单金额/采购预算金额）%" width="220" show-overflow-tooltip>
      <template slot-scope="scope" >
								<span >
								<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.FAmountbill"></el-progress>
								</span>
							</template>
      </el-table-column>
      <el-table-column  prop="FCAmount" label="采购入库金额" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FSAmount" label="采购比（采购入库金额/采购预算金额）%" width="150" show-overflow-tooltip>
      <template slot-scope="scope" >
          <span >
            <el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.FSAmount"></el-progress>
          </span>
        </template>
      </el-table-column>
      <el-table-column  prop="FSCAmount" label="生产领料金额" width="150" show-overflow-tooltip>
      </el-table-column>
        <el-table-column label="生产比（生产领料金额/采购预算金额）%" width="140" prop="FBQty">
        <template slot-scope="scope" >
								<span >
									      <el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.FBQty"></el-progress>
								</span>
							</template>
				</el-table-column>
         </el-table>
      </template>
    </el-table-column>
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column  prop="OName" label="模块" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="sumMoney" label="一级预算金额" width="200" show-overflow-tooltip>
      </el-table-column>
       <!-- <el-table-column  prop="KCMoney" label="库存金额" width="180" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column  prop="FAllAmount" label="采购订单金额" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FAmountbill" label="采购比（采购订单金额/预算金额）%" width="220" show-overflow-tooltip>
      <template slot-scope="scope" >
								<span >
								<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.FAmountbill"></el-progress>
								</span>
							</template>
      </el-table-column>
      <el-table-column  prop="FCAmount" label="采购入库金额" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FSAmount" label="采购比（采购入库金额/预算金额）%" width="150" show-overflow-tooltip>
      <template slot-scope="scope" >
          <span >
            <el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.FSAmount"></el-progress>
          </span>
        </template>
      </el-table-column>
      <el-table-column  prop="FSCAmount" label="生产领料金额" width="150" show-overflow-tooltip>
      </el-table-column>
        <el-table-column label="生产比（生产领料金额/预算金额）%" width="140" prop="FBQty">
        <template slot-scope="scope" >
						<span>
							<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.FSCAmount"></el-progress>
						</span>
					</template>
				</el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="block">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="[10,20,30,40]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="listData.length">
							</el-pagination>
						</div>
  </div>
</template>
<script>
import {
		deptList,
		deptSave,
		deptDelete,
		login,
		GetLB,
		accountset,
		LinkQueryApp,
		LinkUpNextApp,
		OperateBill
	} from '../../api/userMG';

import axios from 'axios';
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import Pagination from   '../../components/Pagination'
import elSelectTree from '../../components/el-select-tree.vue'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      treeData:[],
      payType: [
        
      ],
      payway: [
      ],
      listentryData:[

      ],
      currentPage:1,
		  pageSize:20,
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: '',
        orderNo: '',
        transId: '',
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem('logintoken')
      },
      v_str_AccountID:154,
      value:'',
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
    elSelectTree
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },
methods: {
  /**
   * 里面的方法只有被调用才会执行
   */
  handleSizeChange(val) {
        this.pageSize = val;
       // this.getSelectedValue(this.editForm);
			},
			handleCurrentChange(val) {
        this.currentPage = val;
        //this.getSelectedValue(this.editForm);
			},
  getdata(){
				let arr;
				let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  t_Item  where FItemClassID='3005'\"}]}"
				}
				login(phems).then(data => {
						arr = data.Data.Table
				console.log(arr)
				let att=this.convert(arr)
				this.treeData=att
				})
      },
      convert(list) {
			    let res = []
			    let maps = list.reduce((pre, cur) => { pre[cur.FItemID] = cur; return pre }, {}) 
			    // let maps = new Map(Array.from(list, (x) => [x.id, x])) 
			    for(let i = 0, len = list.length; i < len; i++ ) {
			    let item = list[i]
					item['label']=item['FName']
					item['name']=item['FName']
					item['id']=item['FItemID']
			    if(item.FParentID === 0) {
			      res.push(item)
			    } else {
			    let parent = maps[item.FParentID]
			    // let parent = maps.get(item.parentId)
			  	//	console.log(parent)
			    if (parent) {
			          (parent.children || (parent.children = [])).push(item);
			      }
			    }
			   }
			 return res
      },
      exportExcel() {
      var xlsxParam = { raw: true };
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(
        document.querySelector("#out-table"),
        xlsxParam
      );
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "成本比较表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
      changt(row,expandRows){
         console.log(row)
     
     // this.listentryData=[];

     
			let phems = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"select\":\"select * from AYPordersumAccount where ID  ='"+row.ID+"' and OName in (select FName from YP_module where FParentID =(select FItemID from YP_module where FProjectID ='"+row.ID+"' and FName='"+row.OName+"') ) order by ID,OName  \"}]}"
				}
				login(phems).then(data => {
           let arr= data.Data.Table
           arr.forEach(item => {
           //  console.log(item.FAmount,item.sumMoney,item.FAmount/item.sumMoney)
             item['FAmountbill']=Number(item.FAllAmount/item.sumMoney||0)*100;
             item['FBQty']=Number(item.KCMoney/item.sumMoney||0)*100;
           });
         console.log(arr)
           this.listentryData=arr;
				})

      },
      getSelectedValue(value) {
      console.log(value)
      this.editForm=value
      this.listData=[];
			let phems = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"select\":\"select * from AYPSoft_Amontm where ID  ='"+value.id+"' order by ID,OName  \"}]}"
				}
				login(phems).then(data => {
           let arr= data.Data.Table
           let list={
                 OName:'合计',
                 sumMoney:"",
                 KCMoney:"",
                 FAllAmount:"",
                 FAmountbill:"",
                 FCAmount:"",
                 FSAmount:"",
           }
           arr.forEach(item => {
             list.sumMoney=Number(list.sumMoney || 0) +item.sumMoney;
             list.KCMoney=Number(list.KCMoney || 0) +item.KCMoney;
             list.FAllAmount=Number(list.FAllAmount || 0) +item.FAllAmount;
             list.FCAmount=Number(list.FCAmount || 0) +item.FCAmount;
           //  console.log(item.FAmount,item.sumMoney,item.FAmount/item.sumMoney)
             item['FAmountbill']=Number(item.FAllAmount/item.sumMoney||0)*100;
             item['FBQty']=Number(item.KCMoney/item.sumMoney||0)*100;
             item['FSAmount']=Number(item.FCAmount/item.sumMoney||0)*100;
           });
           list.FAmountbill=Number(list.FAllAmount/list.sumMoney||0)*100;
           list['FSAmount']=Number(list.FCAmount/list.sumMoney||0)*100;
           arr.push(list)
           console.log(arr)
           this.payway=arr;
           this.listData=arr;
				})
			},
    // 分页插件事件
    // callFather(parm) {
    //   this.formInline.page = parm.currentPage
    //   this.formInline.limit = parm.pageSize
    //   this.getdata(this.formInline)
    // },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
    },


    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/payconfig.vue